import React from "react";

import { Box } from "../theme/containers";
import { SecondaryButton } from "../simple-buttons/simple-buttons";

type Props = {
    onClick: (event: any) => void;
    error?: string;
    text?: string;
};

const DatePickerCloseBtn = ({onClick, error, text}: Props) => (
    <Box justifyContent="flex-end" display="flex" clear="both">
        <SecondaryButton
            small
            mb="4"
            mx="4"
            width="auto"
            border="transparent"
            disabled={error ? "disabled" : ""}
            onClick={onClick}
            text={text}
        />
    </Box>
);

export default DatePickerCloseBtn;
